// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"a34c6f75","960":"19a03197"}[chunkId] + ".js";
};